export class PlAngularUtils {
  static waitForPropagation(callback: () => void): void {
    setTimeout(() => callback());
  }
}
